import React from 'react';
import { ReaderPathCheck } from './ReaderPathCheck';
import { Reveal } from './Reveal';
import { PathThread } from './PathThread';
import { HelpCircle } from 'lucide-react';
export function InvisibleReaders() {
  const missingSignals = ['Who read it?', 'What landed?', 'What did they need?', 'What next step fit?'];
  return <section className="py-24 px-6 max-w-4xl mx-auto relative" data-id="element-158">
      <div className="absolute -top-12 left-1/2 -translate-x-1/2" data-id="element-159">
        <PathThread data-id="element-160" />
      </div>

      <div className="text-center mb-20" data-id="element-161">
        <Reveal data-id="element-162">
          <h2 className="text-3xl md:text-5xl font-serif text-navy mb-8 leading-tight" data-id="element-163">
            Most readers never tell you <br data-id="element-164" />
            <span className="italic text-seaglass" data-id="element-165">when the book mattered</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1} data-id="element-166">
          <div className="text-lg text-text-muted leading-relaxed max-w-2xl mx-auto space-y-6" data-id="element-167">
            <p data-id="element-168">
              Someone can buy the book, underline the chapter that sounds
              exactly like their situation, send it to a colleague, bring it
              into a team meeting, and think, "I probably need help with this."
            </p>
            <p data-id="element-169">And still remain invisible to you.</p>
            <p className="font-medium text-navy text-xl" data-id="element-170">
              Not because they did not care. <br className="hidden md:block" data-id="element-171" />
              Because the book never gave them a useful reason to step forward.
            </p>
          </div>
        </Reveal>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-24" data-id="element-172">
        {missingSignals.map((signal, idx) => <Reveal key={idx} delay={0.1 * idx} data-id="element-173">
            <div className="bg-white border border-gray-100 rounded-2xl p-6 text-center shadow-[0_8px_20px_-12px_rgba(26,40,56,0.15)] hover:-translate-y-1 transition-transform duration-300 flex flex-col items-center justify-center min-h-[140px] gap-4 group" data-id="element-174">
              <div className="w-10 h-10 rounded-full bg-paper-dark flex items-center justify-center text-seaglass group-hover:bg-seaglass/10 transition-colors" data-id="element-175">
                <HelpCircle className="w-5 h-5 opacity-50" data-id="element-176" />
              </div>
              <span className="font-serif text-lg text-navy" data-id="element-177">{signal}</span>
            </div>
          </Reveal>)}
      </div>

      <Reveal delay={0.2} data-id="element-178">
        <div id="quick-check-1" className="scroll-mt-32" data-id="element-179">
          <ReaderPathCheck id="q1" checkLabel="Quick Check · 1 of 8" question="When someone raises their hand after engaging with the book, what do you actually know about them?" answers={[{
          id: 'a',
          label: 'A',
          text: 'Usually nothing, or just that they bought, read, or mentioned the book.'
        }, {
          id: 'b',
          label: 'B',
          text: 'I may get their name, email, or a general inquiry.'
        }, {
          id: 'c',
          label: 'C',
          text: 'I can usually see the topic, resource, or problem they were interested in.'
        }, {
          id: 'd',
          label: 'D',
          text: 'I can see their situation, what they care about, and what next step may fit.'
        }]} confirmationText="Saved. This helps check whether serious readers become visible after the book." data-id="element-180" />
        </div>
      </Reveal>
    </section>;
}